import { Request } from '@/classes/Request.ts'

export const clearAutoPaymentSettings = async (districtId: TDistrictId): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/auto_payment_settings/clear/${districtId}`, {})
      .then(result => {
        resolve(result.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
